

import {
	LOAD_PARKINGINCIDENT_DATA,
	DELETE_A_PARKINGINCIDENT,
	SAVE_A_PARKINGINCIDENT,
	UPDATE_A_PARKINGINCIDENT,
	CLEAR_A_PARKINGINCIDENT_ERROR_MESSAGE, UPLOAD_PARKINGINCIDENT_PICTURE, GET_PARKINGINCIDENT_PICTURE_IDS
} from './actions';



import {
	SET_PARKINGINCIDENT_ENDTIME_FILTER,
	SET_PARKINGINCIDENT_MAKE_FILTER,
	SET_PARKINGINCIDENT_PLATE_FILTER,
	SET_PARKINGINCIDENT_MODEL_FILTER, SET_PARKINGINCIDENT_STARTTIME_FILTER,
	SET_PARKINGINCIDENT_STATUS_FILTER,
	SET_PARKINGINCIDENT_VIN_FILTER,
	SET_PARKINGINCIDENT_COLOR_FILTER,
	SET_PARKINGINCIDENT_YEAR_FILTER,
	SET_PARKINGINCIDENT_CLEAR_ALL_FILTER,

} from "./actions";


const initialState = {
	parkingincidentsArray: [],
	parkingincidentsPictureIds: [],
	deleteParkingincidentResp: {},
	errorCMsg: {},
	saveParkingincidentResp: {},
	updateParkingincidentResp: {},
	parkingincidentStatusFilter: "",
	parkingincidentMakeFilter: "",
	parkingincidentVinFilter: "",
	parkingincidentPlateFilter: "",
	parkingincidentModelFilter: "",
	parkingincidentStartTimeFilter: null,
	parkingincidentEndTimeFilter: null,
	parkingincidentColorFilter: "",
	parkingincidentYearFilter: "",
	parkingincidentUploadResponse: {},
};


export default function reducer(state = initialState, action) {
	switch (action.type) {
		case CLEAR_A_PARKINGINCIDENT_ERROR_MESSAGE:
			return Object.assign({}, state, {
				errorCMsg: {}
			});
		case UPLOAD_PARKINGINCIDENT_PICTURE:
			return Object.assign({}, state, {
				parkingincidentUploadResponse: action.parkingincidentUploadResponse,
				errorCMsg: action.errorMsg
			});
		case GET_PARKINGINCIDENT_PICTURE_IDS:
			return Object.assign({}, state, {
				parkingincidentsPictureIds: action.parkingincidentspictureids,
				//errorCMsg: action.errorMsg
			});
		case LOAD_PARKINGINCIDENT_DATA:
			return Object.assign({}, state, {
				parkingincidentsArray: action.parkingincidentsData
			});
		case DELETE_A_PARKINGINCIDENT:
			return Object.assign({}, state, {
				deleteParkingincidentResp: action.deleteParkingincidentResponse,
				errorCMsg: action.errorMsg
			});
		case SAVE_A_PARKINGINCIDENT:
			return Object.assign({}, state, {
				saveParkingincidentResp: action.saveParkingincidentResponse,
				errorCMsg: action.errorMsg
			});
		case UPDATE_A_PARKINGINCIDENT:
			return Object.assign({}, state, {
				updateParkingincidentResp: action.updateParkingincidentResponse,
				errorCMsg: action.errorMsg
			});
		case SET_PARKINGINCIDENT_STATUS_FILTER:
			return Object.assign({}, state, {
				parkingincidentStatusFilter: action.parkingincidentStatusFilter,
			});
		case SET_PARKINGINCIDENT_MODEL_FILTER:
			return Object.assign({}, state, {
				parkingincidentModelFilter: action.parkingincidentModelFilter,
			});
		case SET_PARKINGINCIDENT_VIN_FILTER:
			return Object.assign({}, state, {
				parkingincidentVinFilter: action.parkingincidentVinFilter,
			});
		case SET_PARKINGINCIDENT_PLATE_FILTER:
			return Object.assign({}, state, {
				parkingincidentPlateFilter: action.parkingincidentPlateFilter,
			});
		case SET_PARKINGINCIDENT_MAKE_FILTER:
			return Object.assign({}, state, {
				parkingincidentMakeFilter: action.parkingincidentMakeFilter,
			});
		case SET_PARKINGINCIDENT_STARTTIME_FILTER:
			return Object.assign({}, state, {
				parkingincidentStartTimeFilter: action.parkingincidentStartTimeFilter,
			});
		case SET_PARKINGINCIDENT_ENDTIME_FILTER:
			return Object.assign({}, state, {
				parkingincidentEndTimeFilter: action.parkingincidentEndTimeFilter,
			});

		case SET_PARKINGINCIDENT_COLOR_FILTER:
			return Object.assign({}, state, {
				parkingincidentColorFilter: action.parkingincidentColorFilter,
			});
		case SET_PARKINGINCIDENT_YEAR_FILTER:
			return Object.assign({}, state, {
				parkingincidentYearFilter: action.parkingincidentYearFilter,
			});

		case SET_PARKINGINCIDENT_CLEAR_ALL_FILTER:
			return Object.assign({}, state, {
				parkingincidentStatusFilter: "",
				parkingincidentMakeFilter: "",
				parkingincidentVinFilter: "",
				parkingincidentPlateFilter: "",
				parkingincidentModelFilter: "",
				parkingincidentStartTimeFilter: null,
				parkingincidentEndTimeFilter: null,
				parkingincidentColorFilter: "",
				parkingincidentYearFilter: "",
			});


		default:
			return state;
	}
}
